import api from "./api.config";

const block = (user_id, ip, expired_at) => {
    return api
        .post(`/api/admin/settings/ip/block`, {
            user_id,
            ip,
            expired_at
        })
        .then((response) => {
            return response.data;
        });
};
const unblock = (user_id, ip) => {
    return api
        .post(`/api/admin/settings/ip/unblock`, {
            user_id,
            ip
        })
        .then((response) => {
            return response.data;
        });
};

const SettingsService = {
    block,
    unblock
};

export default SettingsService;